import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-content">
          <h2>About Ailyt</h2>
          <p className="about-intro">
            Ailyt is a leading online learning platform dedicated to transforming lives through quality education in coding and soft skills.
          </p>

          <div className="about-features">
            <div className="feature">
              <div className="feature-number">500+</div>
              <p>Active Students</p>
            </div>
            <div className="feature">
              <div className="feature-number">50+</div>
              <p>Expert Instructors</p>
            </div>
            <div className="feature">
              <div className="feature-number">100+</div>
              <p>Quality Courses</p>
            </div>
            <div className="feature">
              <div className="feature-number">95%</div>
              <p>Success Rate</p>
            </div>
          </div>

          <div className="about-text">
            <h3>Why Choose Ailyt?</h3>
            <ul>
              <li>Industry-standard curriculum designed by experts</li>
              <li>Hands-on projects and real-world applications</li>
              <li>Personalized mentorship and guidance</li>
              <li>Job placement assistance and internship opportunities</li>
              <li>Flexible learning schedules that fit your lifestyle</li>
              <li>Access to exclusive industry partnerships</li>
              <li>Lifetime access to course materials</li>
              <li>Community support and networking opportunities</li>
            </ul>

            <button className="about-btn">Join Our Community</button>
          </div>
        </div>

        <div className="about-image">
          <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=500&fit=crop" alt="Ailyt Community" />
        </div>
      </div>

      {/* Values Section */}
      <div className="values-section">
        <h3>Our Core Values</h3>
        <div className="values-grid">
          <div className="value-card">
            <h4>Excellence</h4>
            <p>We strive for the highest quality in everything we do</p>
          </div>
          <div className="value-card">
            <h4>Innovation</h4>
            <p>Continuously evolving our teaching methods and content</p>
          </div>
          <div className="value-card">
            <h4>Inclusivity</h4>
            <p>Making quality education accessible to everyone</p>
          </div>
          <div className="value-card">
            <h4>Growth</h4>
            <p>Empowering students to reach their full potential</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
